import React from "react";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faCloudDownload, faLayerGroup} from "@fortawesome/free-solid-svg-icons";
import axios from "axios";
import {useParams} from "react-router-dom";
import {Button, Stack} from "react-bootstrap";
import { saveAs } from 'file-saver';

export default function TimelineSessionStart (props) {
    let { studentnumber } = useParams();

    function downloadCT() {
        axios.get("/api/file/images/"+props.data.session.id+"/"+studentnumber,{
            withCredentials: false,
            responseType: 'blob',
            onDownloadProgress: (progressEvent) => {
                var percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
                console.log(percentCompleted)
            },} )
            .then((response) => {
                saveAs(response.data,"ct.zip")
                // return response.d();
            })
            // .then((blob) => {saveAs(blob,"ct.zip")})
            .catch((err) => console.error(`Fetch problem: ${err.message}`));
    }

    function downloadTemplate() {
        console.log(props)
        axios.get("/api/file/template/"+props.data.session.id+"/"+studentnumber,{
            withCredentials: false,
            responseType: 'blob',
            } )
            .then((response) => saveAs(response.data,"template.dcm"))
            .catch((err) => console.error(`Fetch problem: ${err.message}`));
    }

    return(
        <div style={{ color: "#7a7a7a"}} className="text-center d-flex flex-column">
            <p>Session #{props.data.index} start</p>
            <FontAwesomeIcon style={{fontSize: "50px"}} icon={faLayerGroup} />
            <p>Download:</p>
            <Stack direction="horizontal" gap={3}>
                <Button size="sm" onClick={downloadCT}><FontAwesomeIcon icon={faCloudDownload} /> CT</Button>
                <Button size="sm" onClick={downloadTemplate}><FontAwesomeIcon icon={faCloudDownload} /> Template</Button>
            </Stack>

        </div>
    )
}